import { type RedirectRequest, PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from '../config/entra';

const msalInstance = new PublicClientApplication(msalConfig);

let initialized = false;
let initPromise: Promise<void> | null = null;

export const initializeMsal = async () => {
    if (initialized) return;
    if (initPromise) return initPromise;

    initPromise = msalInstance.initialize().then(() => {
        initialized = true;
    });

    return initPromise;
};

// Centralized initialization: also handle redirect promise once and set active account
export const handleLoginRedirect = async () => {
    await initializeMsal();

    const response = await msalInstance.handleRedirectPromise({
        navigateToLoginRequestUrl: false,
    });
    if (response && response.account) {
        msalInstance.setActiveAccount(response.account);
    }

    return response;
};

export const startLoginRedirect = async (request: RedirectRequest) => {
    await initializeMsal();
    return msalInstance.loginRedirect(request);
};

export { msalInstance };
